import { SelfMatchingProfileTab } from "@/components/user-record/self-matching-profile-tab";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile/matching")({
  component: SelfMatchingProfileTab,
});
